<template>

    <div class="div-home">

        <loader-component v-if="showLoader"></loader-component>
        <div v-else class="wrapper-parent">
            <!-- banner -->
            <div class="row">
                <div class="col-md-12">
                    <div class="d-block d-sm-none" v-if="banners != null && banners[12] != null && banners[12].IsActive == true && banners[12].MobPicPath != null">
                        <a target="_blank" :href="banners[12].URL" :title="banners[12].Alt">
                            <img class="w-100" v-if="banners != null && banners[12] != null && banners[12].IsActive == true && banners[12].MobPicPath != null" :src="banners[12].MobPicPath" :alt="banners[12].Alt" :title="banners[12].Alt">
                        </a>
                    </div>
                    <div class="d-none d-sm-block" v-if="banners != null && banners[12] != null && banners[12].IsActive == true && banners[12].PicPath != null">
                        <a target="_blank" :href="banners[12].URL" :title="banners[12].Alt">
                            <img class="w-100" v-if="banners != null && banners[12] != null && banners[12].IsActive == true && banners[12].PicPath != null" :src="banners[12].PicPath" :alt="banners[12].Alt" :title="banners[12].Alt">
                        </a>
                    </div>

                    <div class="d-block d-sm-none" v-if="banners != null && banners[0] != null && banners[0].IsActive == true && banners[0].MobPicPath != null">
                        <a target="_blank" :href="banners[0].URL" :title="banners[0].Alt">
                            <img class="w-100" v-if="banners != null && banners[0] != null && banners[0].IsActive == true && banners[0].MobPicPath != null" :src="banners[0].MobPicPath" :alt="banners[0].Alt" :title="banners[0].Alt">
                        </a>
                    </div>
                    <div class="d-none d-sm-block" v-if="banners != null && banners[0] != null && banners[0].IsActive == true && banners[0].PicPath != null">
                        <a target="_blank" :href="banners[0].URL" :title="banners[0].Alt">
                            <img class="w-100" v-if="banners != null && banners[0] != null && banners[0].IsActive == true && banners[0].PicPath != null" :src="banners[0].PicPath" :alt="banners[0].Alt" :title="banners[0].Alt">
                        </a>
                    </div>
                </div>
            </div>
            <!-- banner -->
            <h1 style="display:none !important">{{baseInfo.ShopName}}</h1>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->
            <div class="wrapper default">
                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar3-component></navbar3-component>
                </header>
                <!-- header -->
                <main class="main default">
                    <div class="container">

                        <div class="row">
                            <div class="col-12 col-lg-12" style="padding-left:0;padding-right:0">
                                <sliders></sliders>
                            </div>
                            <div class="col-12 col-lg-12">
                                <usefulLinks></usefulLinks>
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-12" style="padding-left:0;padding-right:0">
                                <amazing-Offers-FullWidth></amazing-Offers-FullWidth>
                            </div>
                            <!--<div class="col-12 col-lg-12" style="padding-left:0;padding-right:0">
                                <product-categories></product-categories>
                            </div>-->
                        </div>
                        <div class="row banner-ads">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6 col-lg-3">
                                        <div class="widget-banner card" v-if="banners != null && banners[4] != null && banners[4].IsActive == true && banners[4].PicPath != null">
                                            <a target="_blank" :href="banners[4].URL" :title="banners[4].Alt">
                                                <img class="img-fluid" :src="banners[4].PicPath" :alt="banners[4].Alt" :title="banners[4].Alt">
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-6 col-lg-3">
                                        <div class="widget-banner card" v-if="banners != null && banners[5] != null && banners[5].IsActive == true && banners[5].PicPath != null">
                                            <a target="_blank" :href="banners[5].URL" :title="banners[5].Alt">
                                                <img class="img-fluid" :src="banners[5].PicPath" :alt="banners[5].Alt" :title="banners[5].Alt">
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-6 col-lg-3">
                                        <div class="widget-banner card" v-if="banners != null && banners[6] != null && banners[6].IsActive == true && banners[6].PicPath != null">
                                            <a target="_blank" :href="banners[6].URL" :title="banners[6].Alt">
                                                <img class="img-fluid" :src="banners[6].PicPath" :alt="banners[6].Alt" :title="banners[6].Alt">
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-6 col-lg-3">
                                        <div class="widget-banner card" v-if="banners != null && banners[7] != null && banners[7].IsActive == true && banners[7].PicPath != null">
                                            <a target="_blank" :href="banners[7].URL" :title="banners[7].Alt">
                                                <img class="img-fluid" :src="banners[7].PicPath" :alt="banners[7].Alt" :title="banners[7].Alt">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12" style="padding-left:0;padding-right:0">
                                <widget-product :sectionNumber="0"></widget-product>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="widget-banner card" v-if="banners != null && banners[3] != null && banners[3].IsActive == true && banners[3].PicPath != null">
                                    <a target="_blank" :href="banners[3].URL" :title="banners[3].Alt">
                                        <img class="img-fluid" :src="banners[3].PicPath" :alt="banners[3].Alt" :title="banners[3].Alt">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-lg-12">
                                <div class="row">
                                    <div class="col-12" style="padding-left:0;padding-right:0">
                                        <widget-newest-Product></widget-newest-Product>
                                    </div>
                                </div>
                                <div class="row banner-ads">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 col-lg-6">
                                                <div class="widget-banner card" v-if="banners != null && banners[8] != null && banners[8].IsActive == true && banners[8].PicPath != null">
                                                    <a target="_blank" :href="banners[8].URL" :title="banners[8].Alt">
                                                        <img class="img-fluid" :src="banners[8].PicPath" :alt="banners[8].Alt">
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                                <div class="widget-banner card" v-if="banners != null && banners[9] != null && banners[9].IsActive == true && banners[9].PicPath != null">
                                                    <a target="_blank" :href="banners[9].URL" :title="banners[9].Alt">
                                                        <img class="img-fluid" :src="banners[9].PicPath" :alt="banners[9].Alt">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" style="padding-left:0;padding-right:0">
                                        <widget-product :sectionNumber="2"></widget-product>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="widget-banner card" v-if="banners != null && banners[10] != null && banners[10].IsActive == true && banners[10].PicPath != null">
                                            <a target="_blank" :href="banners[10].URL" :title="banners[10].Alt">
                                                <img class="img-fluid" :src="banners[10].PicPath" :alt="banners[10].Alt">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" style="padding-left:0;padding-right:0">
                                        <widget-product :sectionNumber="3"></widget-product>
                                    </div>
                                </div>
                                <div class="row banner-ads">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="widget-banner card" v-if="banners != null && banners[11] != null && banners[11].IsActive == true && banners[11].PicPath != null">
                                                    <a target="_blank" :href="banners[11].URL" :title="banners[11].Alt">
                                                        <img class="img-fluid" :src="banners[11].PicPath" :alt="banners[11].Alt">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" style="padding-left:0;padding-right:0">
                                        <widget-product :sectionNumber="4"></widget-product>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" style="padding-left:0;padding-right:0">
                                        <blogs></blogs>
                                    </div>
                                </div>
                                <!--<div class="row">
                                    <div class="col-12" style="padding-left:0;padding-right:0">
                                        <productReviews></productReviews>
                                    </div>
                                </div>-->
                            </div>
                        </div>
                        <special-brands></special-brands>
                    </div>
                </main>
                <footer-component></footer-component>
                <!--<footer-fixnav-component></footer-fixnav-component>-->
            </div>
        </div>



    </div>
</template>

<script>
    import specialBrands from './specialBrands.vue';
    import sliders from './sliders.vue';
    import blogs from './blogs.vue';
    import productReviews from './productReviews.vue';
    import usefulLinks from './usefulLinks.vue';
    import amazingOffers from './amazingOffers.vue';
    import responsiveamazingOffers from './responsiveamazingOffers.vue';
    import widgetProduct from './widgetProduct.vue';
    import newestProduct from './newestProduct.vue';
    import widgetSuggestion from './widgetSuggestion.vue';
    import amazingOffersFullWidth from './amazingOffersFullWidth.vue'
    import productCategories from './productCategories.vue'
    import { initialSite } from "../../module/initialSite";

    export default {
        data() {
            return {
                banner: 0,
                showLoader: false,
            }
        },
        components: {
            'special-brands': specialBrands,
            'sliders': sliders,
            'usefulLinks': usefulLinks,
            'amazing-offers': amazingOffers,
            'widget-product': widgetProduct,
            'widget-newest-Product': newestProduct,
            'widget-suggestion': widgetSuggestion,
            'responsive-AmazingOffers': responsiveamazingOffers,
            'amazing-Offers-FullWidth': amazingOffersFullWidth,
            'product-categories': productCategories,
            'blogs': blogs,
            'productReviews': productReviews
        },
        computed: {
            banners: function () {
                return this.$store.getters.readBanners;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeMount: function () {
            initialSite(this);
            createPageTitle('فروشگاه اینترنتی');
        }
    }
</script>

<style scoped>
    .amg-pad-rtl {
        padding-right: 0;
    }

    .pad-left {
        padding-left: 0;
    }

    @media only screen and (min-width: 0px) and (max-width: 991px) {
        .amg-pad-rtl, .pad-slider {
            padding-right: 15px !important;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 991px) {
        .pad-left {
            padding-left: 15px;
        }
    }

    .pad-slider {
        padding-right: 0;
    }

    header.main-header {
        padding: 15px 0 8px 0;
        background-color: #fff;
        margin-bottom: 15px;
    }
</style>